
import './App.css';
import AnalyticsTracker from './components/analytics/AnalyticsTracker';
import Navbar from './components/navbar/Navbar';
import Resume from './components/resume/Resume';
import Home from './components/home/Home';
import ProjectsPage from './components/projects/ProjectsPage';
import ContactPage from './components/contact/ContactPage';
import AboutMe from './components/about/AboutMe';
import Footer from './components/footer/Footer';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Helmet } from "react-helmet";

function App() {
  return (
        <Router>
              <Helmet>
                <title>About Me</title>
              </Helmet>
            <AnalyticsTracker />
            <div className="flex flex-col min-h-screen">  
              <Navbar/>
                <div className="flex-grow bg-slate-950">  
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="/resume" element={<Resume />} />
                        <Route path="/projects" element={<ProjectsPage />} />
                        <Route path="/about" element={<AboutMe />} />
                    </Routes>
                </div>
                <Footer />  
            </div>
        </Router>
  );
}

export default App;
